module.exports = __webpack_public_path__ + "static/media/banner_s_05.e849cc93.jpg";